import qs from 'qs'

export function getQueryStrinfied (arg: Record<string, unknown>): string {
  return qs.stringify(arg)
}
